import { observable, computed, action } from 'mobx';
import Alert from 'react-s-alert';
import i18next from 'i18next';

import { AppManager } from 'core';

import { FormStore } from 'libs/forms/app';

import {
  ChangeEmailPreferencesMutation,
  EmailPreferencesQuery,
} from 'apps/profile/gql';

export class EmailPreferencesAppManager extends AppManager {
  static registryName = 'EmailPreferencesAppManager';
  @observable formConf;
  @observable formTarget;
  @observable form;

  constructor(parent, init = {}) {
    super(parent, init);
    this.QueryEmailPreferences();
  }

  @computed
  get loading() {
    return this.queries.get('emailPreferences')?.loading || !this.form;
  }

  @action
  QueryEmailPreferences = () => {
    const q = new EmailPreferencesQuery(this, { queryKey: 'emailPreferences' });
    q.process(emailPreferences => emailPreferences, this.EmailPrefUpdate);
    q.query();
  };

  @action
  EmailPrefUpdate = emailPreferences => {
    if (emailPreferences !== null) {
      this.formConf = {
        fields: {},
        emailPreferences: {
          title: 'Email Preferences:',
          fields: [],
          buttonText: 'Save',
          buttonTextPosting: 'Saving...',
        },
      };
      const newformTarget = {};

      emailPreferences.forEach(emailPref => {
        this.formConf.fields[emailPref.id] = {
          label: i18next.t(`${emailPref.displayName} `),
          descriptionChecked: i18next.t(emailPref.description),
          descriptionUnChecked: i18next.t(emailPref.description),
          component: 'forms.CheckboxField',
          optional: true,
        };
        this.formConf.emailPreferences.fields.push(emailPref.id);
        newformTarget[emailPref.id] = emailPref.enabled;
      });
      this.formTarget = newformTarget;
      this.form = new FormStore(
        this.formTarget,
        this.formConf,
        'emailPreferences',
      );
    }
  };

  @action
  Submit = () => {
    const input = [];
    Object.keys(this.formTarget).forEach(key => {
      input.push({
        id: key,
        enabled: this.formTarget[key],
      });
    });
    this.mutations.push(
      ChangeEmailPreferencesMutation.New(input, {
        onSysErr: this.onSaveError,
        onUserErr: this.onSaveError,
        onSuccess: this.onSaveSuccess,
      }),
    );
  };

  @action
  onSaveError = () => {
    Alert.error(
      i18next.t(
        'Hmm... We failed to update your email preferences. Please try again.',
      ),
    );
  };

  @action
  onSaveSuccess = () => {
    Alert.success(i18next.t('Email preferences updated successfully'));
  };
}
